// extracted by mini-css-extract-plugin
module.exports = {"home":"Button_home__1UBcw","done":"Button_done__T4dsC","working":"Button_working__Y_THk","start":"Button_start__1JZQ_","roundButton":"Button_roundButton__1Y5Aq"};